import styled from 'styled-components';
import Checkbox from 'components/Checkbox';
import { black, grey20, grey400 } from 'styles/colors';

export const Wrapper = styled.li`
	height: 32px;
	color: ${black};
	font-size: 16px;
	letter-spacing: 0.3px;
	line-height: 32px;
	display: flex;

	&.focused {
		background: ${grey20};
	}
`;

export const StyledCheckbox = styled(Checkbox)`
	display: inline-block;
	margin: 4px 0 0 4px;
	cursor: pointer;
	font-size: 22px;

	&[checked='true'] {
		font-size: 29px;
	}
`;

export const Label = styled.span`
	padding-left: 10px;
	cursor: pointer;
	display: inline-block;
	width: 217px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	user-select: none;
	outline: none;

	&.notFocusable {
		cursor: default;
	}
`;

export const ChevronWrapper = styled.span`
	padding-top: 11px;
	outline: none;
`;

export const ChevronArrowRight = styled.span`
	border-right: 2px solid ${grey400};
	border-bottom: 2px solid ${grey400};
	width: 7px;
	height: 7px;
	transform: rotate(-45deg);
	float: right;
	cursor: pointer;
`;
